import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { privateRequest } from "services/privateRequest";
import { GET_DSR, SAVE_DSR } from "services/endPoints";

export const getDsrConfig = createAsyncThunk(
    "dsr/getDsrConfig",
    async (_, { rejectWithValue }) => {
        try {
            const response = await privateRequest.get(GET_DSR);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed to fetch DSR config");
        }
    }
);

export const saveDsrConfig = createAsyncThunk(
    "dsr/saveDsrConfig",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await privateRequest.post(SAVE_DSR, payload);
            return { status: response.status, data: response.data };
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed to save DSR config");
        }
    }
);

const dsrSlice = createSlice({
    name: "dsr",
    initialState: {
        loader: false,
        config: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDsrConfig.pending, (state) => {
                state.loader = true;
                state.error = null;
            })
            .addCase(getDsrConfig.fulfilled, (state, action) => {
                state.loader = false;
                state.config = action.payload?.data;
            })
            .addCase(getDsrConfig.rejected, (state, action) => {
                state.loader = false;
                state.error = action.payload;
            })
            .addCase(saveDsrConfig.pending, (state) => {
                state.loader = true;
                state.error = null;
            })
            .addCase(saveDsrConfig.fulfilled, (state) => {
                state.loader = false;
            })
            .addCase(saveDsrConfig.rejected, (state, action) => {
                state.loader = false;
                state.error = action.payload;
            });
    },
});

export default dsrSlice.reducer;
